import { useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import * as actions from '../../../../../../store';
import {
  filterFindings,
  getAvailableClasses,
  getAvailableTypes,
  handleFilteringLesionType,
  showFilteredOverlays,
} from '../utils/utils';

//Hook for filtering findings by type and class

export const useFindingsFilter = (rightFindings, leftFindings, hoveredClass, hoveredProjections) => {
  const dispatch = useDispatch();
  const [typeValue, setTypeValue] = useState('all');
  const [classValue, setClassValue] = useState('all');

  const handleFilterTypeChange = (event) => {
    const value = event.target.value;
    setTypeValue(value);

    // Reset class filter when type changes to 'all'
    const nextClassValue = value === 'all' ? 'all' : classValue;
    if (value === 'all' && classValue !== 'all') {
      setClassValue('all');
    }

    // Update overlays based on filter
    if (value !== 'all' || nextClassValue !== 'all') {
      showFilteredOverlays(value, nextClassValue, dispatch, actions);
    } else {
      // Restore default overlays when all filters are cleared
      handleFilteringLesionType('opacities', dispatch, actions);
      handleFilteringLesionType('microcalc', dispatch, actions);
    }
  };

  const handleFilterClassChange = (event) => {
    const value = event.target.value;
    setClassValue(value);

    // Update overlays based on filter
    if (typeValue !== 'all' || value !== 'all') {
      showFilteredOverlays(typeValue, value, dispatch, actions);
    } else {
      // Restore default overlays when all filters are cleared
      handleFilteringLesionType('opacities', dispatch, actions);
      handleFilteringLesionType('microcalc', dispatch, actions);
    }
  };

  const handleResetFilters = () => {
    setTypeValue('all');
    setClassValue('all');
    // Restore overlays when filters are reset
    handleFilteringLesionType('opacities', dispatch, actions);
    handleFilteringLesionType('microcalc', dispatch, actions);
  };
  const filteredRightFindings = useMemo(
    () => filterFindings(rightFindings, typeValue, classValue, hoveredClass, hoveredProjections),
    [rightFindings, typeValue, classValue, hoveredClass, hoveredProjections]
  );

  const filteredLeftFindings = useMemo(
    () => filterFindings(leftFindings, typeValue, classValue, hoveredClass, hoveredProjections),
    [leftFindings, typeValue, classValue, hoveredClass, hoveredProjections]
  );

  const hasActiveFilters = typeValue !== 'all' || classValue !== 'all';

  // Get available classes from all findings
  const availableClasses = useMemo(() => {
    const allFindings = [...rightFindings, ...leftFindings];
    return getAvailableClasses(allFindings);
  }, [rightFindings, leftFindings]);

  const availableTypes = useMemo(() => {
    const allFindings = [...rightFindings, ...leftFindings];
    return getAvailableTypes(allFindings);
  }, [rightFindings, leftFindings]);

  return {
    typeValue,
    classValue,
    filteredRightFindings,
    filteredLeftFindings,
    hasActiveFilters,
    availableClasses,
    availableTypes,
    handleFilterTypeChange,
    handleFilterClassChange,
    handleResetFilters,
  };
};
